/**
 * Helper functions for processing order filters
 * Used by both saga and frontend components to ensure consistency
 */

/**
 * Processes complex order filters exactly like in saga
 * Transforms arrays into strings with operators
 *
 * @param {Object} filters - Raw filters object
 * @returns {Object} - Processed filters with incService, excService, etc.
 */
export const processOrderFilters = (filters) => {
  let {
    service, serviceMode, serviceOperator,
    status, statusMode,
    incAlert, alertOperator,
    vidStatuses, underReviewStatus, duplicateReviewStatus,
    range,
    ...rest
  } = filters;

  // Process service filters with operators (INC/EXC)
  let incService, excService;
  if (serviceMode === "INC") {
    incService = (service || []).join(",");
    if (incService.length > 0) {
      incService = `${serviceOperator}:,` + incService;
    }
  } else {
    excService = (service || []).join(",");
    if (excService.length > 0) {
      excService = `${serviceOperator}:,` + excService;
    }
  }

  // Process status filters with operators (INC/EXC)
  let incStatus, excStatus;
  if (statusMode === "INC") {
    incStatus = (status || []).join(",");
  } else {
    excStatus = (status || []).join(",");
  }

  // Process alert filters with operator
  let alert = (incAlert || []).join(",");
  if (alert.length > 0) {
    alert = `${alertOperator}:,` + alert;
  }

  // Process other array filters
  const vidStatus = (vidStatuses || []).join(",");
  underReviewStatus = (underReviewStatus || []).join(",");
  duplicateReviewStatus = (duplicateReviewStatus || []).join(",");
  const submittedBetween = range

  return {
    incService,
    excService,
    incStatus,
    excStatus,
    alert,
    vidStatus,
    underReviewStatus,
    duplicateReviewStatus,
    submittedBetween,
    ...rest
  };
};

/**
 * Normalizes formik values for order filters
 * Applies the same transformations as in onSubmit
 *
 * @param {Object} values - Raw values from formik
 * @returns {Object} - Processed values for filters
 */
export const normalizeOrderFilterValues = (values) => {
  const v = { ...values };

  // Process orderNotaries the same way as in onSubmit
  if (v.orderNotaries === '') v.orderNotaries = 0;
  if (!v.service?.includes('notary') || v.serviceMode === 'EXC') {
    delete v.orderNotaries;
  }
  // Transform range array into submittedBetween string
  const submittedBetween = v.range?.length > 1 ? v.range.join('-') : null;
  const { range, _set, ...rest } = v;

  return { ...rest, submittedBetween };
};
